import React, { useState, useEffect } from "react";
import { startRegistration } from "@simplewebauthn/browser";
import Cookies from "js-cookie";
import { MobileView } from "react-device-detect";
import { AddToHomeScreen } from "react-pwa-add-to-homescreen";
import axios from "axios";
import Popup from "reactjs-popup";
import "../../App.css";
import "./Questionnaires.css";
import Header from "./../../components/Header/Header";
import { Link, useHistory } from "react-router-dom";
import prettyMilliseconds from "../../handlers/pretty-ms-hebrew";
import {
  getFirstName,
  getWordByGender,
  getFamilyCon,
} from "../../handlers/dictionaryHandler.js";
import Footer from "./../../components/Footer/Footer";
import NotificationManager from "../../utils/NotifcationManager";

import MyPopup from "./../../components/MyPopup/MyPopup";
import DiceLoading from "../../components/DiceLoading.js";
import ShareCardModal from "../../components/ShareCardModal.js";
import AddHelperModal from "../../components/AddHelperModal";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
};

const checkIfShouldOfferPasskey = async () => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_LOCALHOST_ADDRESS + "/passkey/register/options",
      {},
      config,
    );
    return true;
  } catch (error) {
    // status is 409
    if (error.response && error.response.status === 409) {
      return false;
    } else {
      return true;
    }
  }
};

const Questionnaires = () => {
  const history = useHistory();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isErrorMessageDisplayed, setIsErrorMessageDisplayed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [aboutMeGood, setAboutMeGood] = useState(0);
  const [aboutPartnerGood, setAboutPartnerGood] = useState(0);
  const [mirorGood, setMirorGood] = useState(0);
  const [picGood, setPicGood] = useState(0);
  // const [haredGood, setHaredGood] = useState(0);
  const [isDetailsGoodDisplayed, setIsDetailsGoodDisplayed] = useState(false);
  const [messegeAboutDetails, setMessegeAboutDetails] = useState();
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [conHelperSignUp, setConHelperSignUp] = useState("");
  const [fullNameHelperSignUp, setFullNameHelperSignUp] = useState("");
  const [letHelper, setLetHelper] = useState(false);
  const [isHelperModalOpen, setIsHelperModalOpen] = useState(false);
  const [openShareCard, setOpenShareCard] = useState(false);
  const [timeLeft, setTimeLeft] = useState();
  const [areDetailsGood, setAreDetailsGood] = useState(true);
  const [inFreezeUse, setInFreezeUse] = useState(false);
  const [cntMatches, setCntMatches] = useState(0);
  const [showSetPasswordPopup, setShowSetPasswordPopup] = useState(false);
  const [showPasskeyOffer, setShowPasskeyOffer] = useState(false);
  const [questionnaires, setQuestionnaires] = useState(null);
  useEffect(() => {
    const defaultQuestionnaires = [
      {
        type: "findplace",
        text: getWordByGender("findPlace"),
        to: "/findplace",
        icon: "findplaceicon",
      },
      {
        type: "edit",
        text: getWordByGender("editDetails"),
        to: "/edit",
        icon: "editicon",
      },

      {
        type: "match",
        text: getWordByGender("newMatches"),
        to: "/doublematch",
        getIcon: () => {
          const matchCount = cntMatches;
          if (matchCount == 0) {
            return "doublematchicon";
            // } else if (matchCount == 1) {
            //   return "circle_1icon";
          }

          // 2
          return "circle_icon";
        },
      },
      {
        type: "matchPast",
        text: getWordByGender("prevMatches"),
        to: "/prevmatches",
        icon: "prev_icon",
      },

      // {
      //   type: "forum",
      //   text: "הפורום",
      //   to: "/questionnaires",
      //   icon: "forumicon",
      // },
      // { type: "forum", text: "הפורום", to: "/forumrooms", icon: "forumicon" },

      // {
      //   type: "blog",
      //   text: "בלוג ",
      //   to: "/blog",
      //   icon: "forumicon",
      // },
    ];

    setQuestionnaires(defaultQuestionnaires);
    if (!Cookies.get("welcome")) {
      // להציג את הפופאפ
      // Cookies
    }
  }, [cntMatches]);

  useEffect(() => {
    try {
      // console.log("Register notification started");
      NotificationManager.register();
    } catch (error) {
      console.log(error);
    }
  }, []);

  const alertUser = (message) => {
    setIsErrorMessageDisplayed(true);
    setErrorMessage(message);
  };

  const insertFunDate = async (kind) => {
    try {
      // console.log(kind);
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/insertFunDates",
        { kind: kind },
        config,
      );

      if (response.data === true) {
        //
      }
    } catch (error) {
      //
    }
  };

  const registerPasskey = async () => {
    setShowPasskeyOffer(false);

    try {
      // console.log(
      //   "starting registration, sending request to server to get options",
      // );
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/passkey/register/options",
        {},
        config,
      );

      const options = response.data;
      const username = response.data.userName;

      // console.log("options", options);
      const verificationResponse = await startRegistration({
        optionsJSON: options,
      });

      console.log("verificationResponse", verificationResponse);

      const verifyResponse = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/passkey/register/verify",
        verificationResponse,
        config,
      );

      alertUser("הסיסמה החדשה נרשמה בהצלחה, תוכל להשתמש בה מהפעם הבאה שתתחבר");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);
    // Clear timeout if the component is unmounted
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!isDataLoaded) return;

    const loginByOtp = localStorage.getItem("loginByOtp");
    const cntSetPasswordPopup = parseInt(
      localStorage.getItem("cntSetPasswordPopup") || "0",
    );

    if (loginByOtp === "1" && cntSetPasswordPopup < 3) {
      setShowSetPasswordPopup(true);
    }
  }, [isDataLoaded]);

  useEffect(() => {
    const openPasskeyOffer = async () => {
      const shouldOfferPasskey = await checkIfShouldOfferPasskey();

      if (shouldOfferPasskey) {
        localStorage.removeItem("passkeyOfferClosed");
        setShowPasskeyOffer(true);
      } else {
        alertUser("כניסה מהירה כבר מוגדרת במכשיר הזה");
      }
    };

    window.addEventListener("openPasskeyOffer", openPasskeyOffer);

    return () => {
      window.removeEventListener("openPasskeyOffer", openPasskeyOffer);
    };
  }, []);

  useEffect(() => {
    const updateShouldOfferPasskey = async () => {
      const passkeyOfferClosed = localStorage.getItem("passkeyOfferClosed");
      if (passkeyOfferClosed === "1") {
        setShowPasskeyOffer(false);
      } else {
        // console.log("checking against server");
        const shouldOfferPasskey = await checkIfShouldOfferPasskey();
        // console.log("shouldOfferPasskey", shouldOfferPasskey);
        setShowPasskeyOffer(shouldOfferPasskey);
      }
    };

    updateShouldOfferPasskey();
  }, [isDataLoaded]);
  console.log("shold offer passkey", showPasskeyOffer);
  const closeSetPasswordPopup = () => {
    const currentCount = parseInt(
      localStorage.getItem("cntSetPasswordPopup") || "0",
    );

    localStorage.setItem("cntSetPasswordPopup", currentCount + 1);
    setShowSetPasswordPopup(false);
  };

  const goToSetPassword = () => {
    localStorage.removeItem("loginByOtp");
    history.push("/changepassword");
  };

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     changeImage();
  //   }, 2500);
  //   return () => clearInterval(timer);
  // }, []);

  const changeImage = () => {
    if (document.getElementById("topad")) {
      if (
        document.getElementById("topad").style.backgroundImage ===
        'url("/topadimgs/topad1.png")'
      ) {
        document.getElementById("topad").style.backgroundImage =
          'url("/topadimgs/topad2.png")';
      } else if (
        document.getElementById("topad").style.backgroundImage ===
        'url("/topadimgs/topad2.png")'
      ) {
        document.getElementById("topad").style.backgroundImage =
          'url("/topadimgs/topad3.png")';
      } else {
        document.getElementById("topad").style.backgroundImage =
          'url("/topadimgs/topad1.png")';
      }
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(
          process.env.REACT_APP_LOCALHOST_ADDRESS + "/pAreDetailseGood",
          config,
        );

        localStorage.setItem("lastMatchChosen", 0);
        const userData = response.data;

        setAboutMeGood(userData.aboutMeGood);
        setAboutPartnerGood(userData.aboutPartnerGood);
        setMirorGood(userData.mirorGood);
        setPicGood(userData.picGood);
        // setHaredGood(userData.haredGood);
        setCntMatches(userData.cntMatches);
        localStorage.setItem("cntMatches", userData.cntMatches);
        setInFreezeUse(userData.inFreezeUse);
        setFullNameHelperSignUp(userData.fullNameHelperSignUp);
        setConHelperSignUp(userData.conHelperSignUp);
        setLetHelper(userData.letHelper == 1 ? true : false);
        setIsDataLoaded(true);

        const popupWhatsupElement = document.getElementById("popupWhatsup");
        if (popupWhatsupElement) {
          if (Cookies.get("popupWhatsup")) {
            popupWhatsupElement.style.display = "auto";
          } else {
            popupWhatsupElement.style.display = "none";
          }
        }
        if (
          userData.aboutMeGood != 1 ||
          userData.aboutPartnerGood != 1 ||
          userData.mirorGood != 1 ||
          userData.picGood != 1
          // userData.haredGood != 1
        ) {
          // setIsDetailsGoodDisplayed(true);
          // newUser = true;

          setAreDetailsGood(false);
          setIsDetailsGoodDisplayed(true);
          setMessegeAboutDetails(
            ` שימו לב, על מנת לקבל התאמות ביום שלישי, עליכם למלא את כל הפרטים`,
          );
        } else {
          // setIsDetailsGoodDisplayed(true);
          // setMessegeAboutDetails(
          //   `יש! מילאתם את כל הפרטים, דאבל מחפש לך התאמות, ויציג אותן ביום שלישי`
          // );
        }
      } catch (error) {
        // probebly user is not authenticated or server is down
      }
    }
    fetchData();
  }, []);

  const calculateTimeLeft = () => {
    let nextTuesday = new Date();
    // nextTuesday.setDate(nextTuesday.getDate() + (2 + 7 - nextTuesday.getDay()));
    nextTuesday.setDate(
      nextTuesday.getDate() + ((1 + 7 - nextTuesday.getDay()) % 7),
    );
    nextTuesday.setHours(23);
    nextTuesday.setMinutes(59);
    nextTuesday.setSeconds(59);
    // console.log(nextTuesday);

    return prettyMilliseconds(nextTuesday.getTime() - currentDate.getTime(), {
      compact: false,
      verbose: true,
    });
  };

  const onClickLetHelper = async (value) => {
    setLetHelper(value);
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/letFriendSeeMatches",
        // send 0 even thogh its the oposite from logic, cause react didnt refresh the value
        { letFriend: value ? 1 : 0 },
        config,
      );

      if (response.data === true) {
        // history.push("/questionnaires");
        // alertUser("");
        setIsErrorMessageDisplayed(false);
      } else {
        alertUser("יש שגיאה בשרת או שאבד החיבור לאינטרנט, אנא נסה שנית");
      }
    } catch (error) {
      alertUser("יש שגיאה בשרת או שאבד החיבור לאינטרנט, אנא נסה שנית");
    }
  };

  const onFreezeUse = async (checked) => {
    setInFreezeUse(checked);
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/freezeUse",
        // send 0 even thogh its the oposite from logic, cause react didnt refresh the value
        { toFreeze: checked ? 1 : 0 },
        config,
      );

      if (response.data === true) {
        // history.push("/questionnaires");
        // alertUser("");
        setIsErrorMessageDisplayed(false);
      } else {
        alertUser("יש שגיאה בשרת או שאבד החיבור לאינטרנט, אנא נסה שנית");
      }
    } catch (error) {
      alertUser("יש שגיאה בשרת או שאבד החיבור לאינטרנט, אנא נסה שנית");
    }
  };
  const goToHelperHome = () => {
    history.push("/helperhome");
  };

  const renderQuestionnairesButtons = () => {
    const QuestionnairesButtons = questionnaires.map((questionnaire) => (
      <Link
        to={questionnaire.to}
        style={{ textDecoration: "none" }}
        key={questionnaire.type}
      >
        <div
          className="button questionnaire-btn "
          style={{ height: "44px", lineHeight: "44px", marginBottom: "8px" }}
          onClick={() =>
            questionnaire.type === "fun"
              ? insertFunDate(1)
              : questionnaire.type === "findplace"
                ? insertFunDate(2)
                : ""
          }
        >
          <div className="btn-questionnaire-text">
            {questionnaire.text} <div className="error"></div>
          </div>
          <div className="details-not-good">
            {questionnaire.type === "edit" && !areDetailsGood ? "חסר!" : ""}
          </div>

          <div
            className={
              questionnaire.getIcon
                ? questionnaire.getIcon()
                : questionnaire.icon
            }
          >
            <div
              className="details-not-good"
              style={{ paddingRight: "14px", lineHeight: "38px" }}
            >
              {questionnaire.type === "match" && cntMatches > 0
                ? cntMatches
                : ""}
            </div>
          </div>
          <div
            className={questionnaire.type === "fun" ? "vip" : ""}
            style={{ float: "left" }}
          ></div>
        </div>
      </Link>
    ));

    return (
      <div className="questionnaires-buttons">{QuestionnairesButtons}</div>
    );
  };
  return (
    <form className="questionnaries-form">
      {isDataLoaded === true ? (
        <>
          <div className="full-screen questionnaires">
            <Header />
            <div id="sub-header">
              <div
                className="exit-sub-header"
                onClick={() => {
                  document.getElementById("sub-header").style.display = "none";
                }}
              >
                x
              </div>
              <div className="text-sub-header">
                {/* <a href="whatsapp://send/?text=הי מה המצב? אני רוצה להמליץ לך לנסות אתר קצת שונה וממש שווה, הוא שדכן וירטואלי.. זה הקישור: https://double2love.com בתקווה לבשורות טובות ושלום במהרה!">
                  <div
                    className="adtopmainscreen"
                    id="topad"
                    style={{ backgroundImage: 'url("/topadimgs/topad2.png")' }}
                  ></div>
                </a> */}

                {/* <a
                  // href={`https://wa.me/972544964890?text=הי+נדב+אשמח+לשמוע+על+רבע+שעה+אימון+זוגי+מתנה+,+הגעתי+אליך+מאתר+דאבל. ${getFirstName()}`}
                  // href={"https://ekai.short.gy/M77f7X"}
                  href="https://datenight.ai/double2love"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="white"
                >
                  
                  <div className="speedate"></div>
                </a> */}
                {/* <div className="tubishvat"></div> */}

                {/* <div className="topadreview"></div>
                <PrevMatches /> */}

                {/* <Link to="/sharecard" style={{ textDecoration: "none" }}> */}
                <div
                  className="mainButton"
                  style={{
                    fontSize: "18px",
                    padding: "6px 12px",
                    marginTop: "10px",
                  }}
                  onClick={() => setOpenShareCard(true)}
                >
                  {"שיתוף הפרופיל להגדלת חשיפה"}
                </div>
                {/* </Link> */}
              </div>
            </div>
            <div
              onClick={() => {
                if (
                  document.getElementById("slidepanel1").style.width === "200px"
                ) {
                  document.getElementById("slidepanel1").style.width = "0px";
                }
                const popupWhatsupElement =
                  document.getElementById("popupWhatsup");
                if (popupWhatsupElement && popupWhatsupElement.style) {
                  popupWhatsupElement.style.display = "none";
                }
              }}
            >
              <div className="questionnaires-container">
                <div className="questionnaires-body">
                  {/* <div className="title-questionaries">
                    {" "}
                    {cntMatches > 0
                      ? "דאבל מצא לך התאמה חדשה 💫"
                      : inFreezeUse
                        ? "הינך בהשהייה - אפשר לשנות בתחתית המסך"
                        : !areDetailsGood
                          ? "היכנסו להשלים את הפרופיל"
                          : "דאבל מחפש התאמה בעוד "}
                  </div> */}

                  <div className="title-questionaries">
                    {cntMatches > 0 ? (
                      <>דאבל מצא לך התאמה חדשה 💫</>
                    ) : inFreezeUse ? (
                      <>
                        הפרופיל בהשהייה, ניתן לשנות{" "}
                        <Link
                          to="/myprofile"
                          style={{
                            color: "var(--border-color)",
                            textDecoration: "underline",
                            fontWeight: "700",
                          }}
                        >
                          כאן
                        </Link>
                      </>
                    ) : !areDetailsGood ? (
                      <>
                        יש להשלים את הפרופיל{" "}
                        <Link
                          to="/edit"
                          style={{
                            color: "var(--border-color)",
                            textDecoration: "underline",
                            fontWeight: "700",
                          }}
                        >
                          כאן
                        </Link>
                      </>
                    ) : (
                      <>דאבל מחפש התאמה בעוד</>
                    )}
                  </div>

                  <div
                    className={
                      cntMatches > 0
                        ? "invisible"
                        : "time-till-date-counter-contianer"
                    }
                  >
                    <span className="title-questionaries">
                      {" "}
                      {areDetailsGood && cntMatches === 0 && !inFreezeUse
                        ? `${calculateTimeLeft()}`
                        : " "}{" "}
                    </span>
                  </div>

                  {/* {conHelperSignUp > 0 && (
                    <div
                      className="pause-card"
                      style={{
                        marginBottom: "14px",
                        padding: "8px 5px",
                        background: "var(--container-color)",
                        border: "1px solid var(--grey-color)",
                        borderRight: "4px solid var(--border-color)",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                        borderRadius: "18px",
                      }}
                    >
                      <div
                        className="faceline"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: "2px",
                        }}
                      >
                        <div
                          className="pause-title"
                          style={{
                            marginBottom: "0px",
                          }}
                        >
                          הדאבליסט שלי {getFamilyCon(conHelperSignUp)}:{" "}
                          {fullNameHelperSignUp}
                        </div>

                        <div
                          onClick={() => setIsHelperModalOpen(true)}
                          style={{
                            fontSize: "14px",
                            color: "var(--title-color)",
                            opacity: "0.8",
                            textDecoration: "underline",
                            cursor: "pointer",
                            lineHeight: "1",
                          }}
                        >
                          החלפה
                        </div>
                      </div>

                      <label className="checkbox-row">
                        <input
                          type="checkbox"
                          checked={!!letHelper}
                          onChange={(e) => onClickLetHelper(e.target.checked)}
                        />

                        <span
                          className="status-main-text"
                          style={{
                            fontSize: "14px",
                          }}
                        >
                          לאפשר לדאבליסט לצפות בהתאמות שלי
                        </span>
                      </label>
                    </div>
                  )} */}

                  <div className="triple-actions-row">
                    {/* שיתוף כרטיס */}
                    {/* <div className="action-btn" onClick={() => setOpen(true)}>
                      <div className="shareicon action-icon" />
                      <div className="action-text">שיתוף הפרופיל שלי</div>
                    </div>*/}
                    <ShareCardModal
                      isOpen={openShareCard}
                      onClose={() => setOpenShareCard(false)}
                    />

                    {/* דאבליסט */}
                    <div
                      className="action-btn border-right"
                      onClick={() => setIsHelperModalOpen(true)}
                    >
                      <div className="edithelpericon action-icon" />
                      <div className="action-text">
                        {conHelperSignUp > 0 ? "הדאבליסט שלי" : "דאבליסט מלווה"}
                      </div>
                      {conHelperSignUp > 0 && (
                        <div className="action-text">
                          ({fullNameHelperSignUp})
                        </div>
                      )}
                    </div>

                    <AddHelperModal
                      isOpen={isHelperModalOpen}
                      onClose={() => setIsHelperModalOpen(false)}
                      initialFullName={fullNameHelperSignUp}
                      initialAllowSee={letHelper}
                      hasHelper={conHelperSignUp > 0}
                    />

                    {/* קבוצת ווטסאפ */}
                    <a
                      href="https://chat.whatsapp.com/CC5ApSvw7lpIYoujWAzHkv"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="action-btn"
                    >
                      <div className="whatsuppgrey action-icon" />
                      <div className="action-text">קבוצת ווטסאפ לעדכונים</div>
                    </a>

                    {/* ליווי AI */}
                    <a
                      href="https://ekai.short.gy/M77f7X"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="action-btn"
                    >
                      <div className="helphandsicon action-icon" />
                      <div className="action-text">ליווי AI אישי</div>
                    </a>
                  </div>

                  <Popup
                    open={showSetPasswordPopup}
                    contentStyle={{
                      maxWidth: "360px",
                      width: "85%",
                      borderRadius: "18px",
                      direction: "rtl",
                      padding: "22px",
                      textAlign: "center",
                    }}
                    closeOnDocumentClick={false}
                    closeOnEscape={false}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          marginBottom: "10px",
                        }}
                      >
                        הגדרת סיסמה
                      </div>

                      <div
                        style={{
                          fontSize: "15px",
                          lineHeight: "1.6",
                          marginBottom: "18px",
                        }}
                      >
                        נכנסת באמצעות קוד חד־פעמי שנשלח למייל.
                        <br />
                        כדי להתחבר בקלות בפעמים הבאות, מומלץ להגדיר סיסמה קבועה.
                      </div>

                      <div
                        className="mainButton"
                        onClick={goToSetPassword}
                        style={{ marginBottom: "10px", cursor: "pointer" }}
                      >
                        הגדרת סיסמה
                      </div>

                      <div
                        onClick={closeSetPasswordPopup}
                        style={{
                          fontSize: "14px",
                          color: "var(--title-color)",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        אולי בהמשך
                      </div>
                    </div>
                  </Popup>

                  <Popup
                    open={isDetailsGoodDisplayed}
                    contentStyle={{
                      maxWidth: "45%",
                      borderRadius: "5px",
                      direction: "rtl",
                    }}
                    position="right center"
                    onClose={() => setIsDetailsGoodDisplayed(false)}
                    closeOnDocumentClick
                    closeOnEscape
                  >
                    {messegeAboutDetails}
                  </Popup>

                  <div
                    className={
                      localStorage.getItem("newUser") == 1
                        ? "newUserPopup"
                        : "invisible"
                    }
                    id="newUser"
                  >
                    <div
                      className="exit-popup"
                      onClick={() => {
                        document.getElementById("newUser").style.display =
                          "none";
                        localStorage.setItem("newUser", 0);
                      }}
                    >
                      x
                    </div>
                    <div>
                      {" "}
                      {getFirstName()}! יש! קיבלת חודש מנוי מתנה! מקווים שתהיה
                      לך חוויה טובה :)
                    </div>
                  </div>

                  <div
                    className={
                      Cookies.get("newUser") == 1 &&
                      areDetailsGood &&
                      localStorage.getItem("cntExitNewUser") < 3
                        ? "newUserPopup"
                        : "invisible"
                    }
                    id="newUserFP"
                  >
                    <div
                      className="exit-popup"
                      onClick={() => {
                        var y = parseInt(
                          localStorage.getItem("cntExitNewUser"),
                        );
                        if (localStorage.getItem("cntExitNewUser") == null) {
                          y = 0;
                        }

                        y = parseInt(y) + 1;
                        localStorage.setItem("cntExitNewUser", y);
                        document.getElementById("newUserFP").style.display =
                          "none";
                      }}
                    >
                      x
                    </div>
                    <div>
                      {" "}
                      {getFirstName()} רוצה לראות מבצע למצטרפים חדשים להיום
                      בלבד?
                      <Link to="/Subscribe"> כאן </Link>
                    </div>
                  </div>

                  {renderQuestionnairesButtons()}

                  {/* {cntMatches > 0 ? <MyPopup /> : <></>} */}
                  {cntMatches > 0 && <MyPopup />}
                  {/* <div className="lineDice" /> */}

                  {Cookies.get("userType") === "3" && (
                    <div className="helper-entry-card" onClick={goToHelperHome}>
                      <div className="helper-entry-icon">🌷</div>
                      <div className="helper-entry-text">
                        <div className="helper-entry-title">
                          אזור דאבליסטים מלווים
                        </div>
                        <div className="helper-entry-subtitle">
                          לצפייה במועמדים שרשמת ולעזרה בהתאמות
                        </div>
                      </div>
                    </div>
                  )}

                  {/* <div
                    className="pause-card"
                    style={{
                      padding: "10px 14px",
                      marginTop: "12px",
                      marginBottom: "8px",
                      border: "1px solid var(--grey-color)",
                      borderRadius: "18px",
                      boxShadow: "-moz-initial0 2px 8px rgba(0,0,0,0.04)",
                      background: "var(--container-color)",
                    }}
                  >
                    <label
                      className="checkbox-row"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                        margin: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={!inFreezeUse}
                        onChange={(e) => onFreezeUse(!e.target.checked)}
                        style={{
                          width: "22px",
                          height: "22px",
                          accentColor: "var(--border-color)",
                        }}
                      />

                      <span
                        className="status-main-text"
                        style={{
                          fontSize: "17px",
                          fontWeight: "700",
                          whiteSpace: "nowrap",
                        }}
                      >
                        סטטוס הפרופיל: {!inFreezeUse ? "פעיל" : "בהשהייה"}
                      </span>
                    </label>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#777",
                        textAlign: "center",
                        marginTop: "4px",
                      }}
                    >
                      כדי לשנות את הסטטוס, לחצו על הסימון
                    </div>
                  </div> */}
                  <div
                    onClick={() => {
                      Cookies.remove("userId");
                      localStorage.setItem("newUser", 0);
                      history.push("/");
                    }}
                    // className="reset-password-button"
                    id="backBtn"
                    className="newGentleBack"
                  >
                    יציאה
                  </div>
                  {isErrorMessageDisplayed && (
                    <div className="error-message">
                      <h5>{errorMessage} </h5>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {showPasskeyOffer && (
              <div className="passkey-overlay">
                <div className="passkey-card">
                  <div className="passkey-icon">🔐</div>

                  <div className="passkey-title">כניסה מהירה ובטוחה</div>

                  <div className="passkey-text">
                    רוצה שבפעם הבאה תיכנסי לדאבל באמצעות נעילת הטלפון?
                    <br />
                    טביעת אצבע, זיהוי פנים או קוד מכשיר.
                  </div>

                  <button
                    type="button"
                    className="passkey-main-btn"
                    // className="passkey-secondary-btn"
                    onClick={registerPasskey}
                  >
                    כן, להפעיל כניסה מהירה
                  </button>

                  <button
                    type="button"
                    className="passkey-secondary-btn"
                    onClick={() => {
                      localStorage.setItem("passkeyOfferClosed", "1");
                      setShowPasskeyOffer(false);
                    }}
                  >
                    לא עכשיו
                  </button>
                </div>
              </div>
            )}
            <MobileView>
              <AddToHomeScreen
                skipFirstVisit={true}
                translate={{
                  headline: "הוספה למסך הבית",
                  bottomline: "לחיצה כאן",
                  chromiumAddHomeScreen: "הוספה למסך הבית - לחץ כאן",
                  chromiumInstall: "האייקון יוצג על מסך הבית",
                }}
                cookie={{
                  name: "add-to-home-screen5",
                  // expireDays: 180,
                }}
              />
            </MobileView>
          </div>
          <Footer />
        </>
      ) : (
        <DiceLoading />
      )}
    </form>
  );
};

export default Questionnaires;
